"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseInlineResponse2001 = void 0;
const iclient_entity_1 = require("./iclient-entity");
function parseInlineResponse2001(data) {
    if (data.clients !== null && typeof data.clients === 'object')
        data.clients = data.clients.map((x) => (0, iclient_entity_1.parseIClientEntity)(x));
    return data;
}
exports.parseInlineResponse2001 = parseInlineResponse2001;
